import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { Component, OnInit } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { UiService } from 'src/app/services/ui.service';
import { ThemeService } from 'src/app/services/client/theme/theme.service';

@Component({
  selector: 'app-support-contact-modal',
  templateUrl: './support-contact-modal.component.html',
  styleUrls: ['./support-contact-modal.component.scss'],
})
export class SupportContactModalComponent implements OnInit {
  codeCopied: boolean;
  support: { chatSupport: string; emailSupport: string } = {
    chatSupport: '',
    emailSupport: '',
  };
  constructor(
    private modalCtrl: ModalController,
    private analyticsService: AnalyticsService,
    private uiService: UiService,
    private themeService: ThemeService
  ) {}

  ngOnInit() {
    this.support.chatSupport = this.themeService.getChatSupport;
    this.support.emailSupport = this.themeService.getEmailSupport;
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  requestCall() {
    console.log('Request call clicked');
    // Add your call request logic here
    this.modalCtrl.dismiss({ action: 'request-call' });
  }

  copyToClipboard(text: string) {
    this.analyticsService.trackUnified('copy_code_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      button: 'Copy Code',
      text,
    });
    navigator.clipboard.writeText(text).then(() => {
      this.uiService.presentToast('Copied to clipboard');
      this.codeCopied = false;
      setTimeout(() => {
        this.codeCopied = false;
      }, 2000);
    });
  }
}
